import Image from 'next/image';

import { CMSBlockWrapper } from '../cms-block-wrapper';

import css from './two-columns-block-view.css';

import type { TwoColumnsBlockViewModel } from '../../view-models/blocks/two-columns-block.viewModel';

export function TwoColumnsBlockView(viewModel: TwoColumnsBlockViewModel) {
  return (
    <CMSBlockWrapper contentClassName={css.content}>
      <div className={css.column}>
        {viewModel.leftBackgroundImage ? (
          <Image
            className={css.columnBackground}
            src={viewModel.leftBackgroundImage.src}
            alt={viewModel.leftBackgroundImage.alt}
            layout="fill"
          />
        ) : null}
        <div className={css.columnContent}>
          {viewModel.leftLogo ? (
            <Image
              className={css.columnLogo}
              src={viewModel.leftLogo.src}
              alt={viewModel.leftLogo.alt}
              width={1}
              height={60}
            />
          ) : null}
          <h6 className={css.columnTitle}>{viewModel.leftTitle}</h6>
          <div dangerouslySetInnerHTML={{ __html: viewModel.leftBody.processed }} />
        </div>
      </div>
      <div className={css.column}>
        {viewModel.rightBackgroundImage ? (
          <Image
            className={css.columnBackground}
            src={viewModel.rightBackgroundImage.src}
            alt={viewModel.rightBackgroundImage.alt}
            layout="fill"
          />
        ) : null}
        <div className={css.columnContent}>
          {viewModel.rightLogo ? (
            <Image
              className={css.columnLogo}
              src={viewModel.rightLogo.src}
              alt={viewModel.rightLogo.alt}
              width={1}
              height={60}
            />
          ) : null}
          <h6 className={css.columnTitle}>{viewModel.rightTitle}</h6>
          <div dangerouslySetInnerHTML={{ __html: viewModel.rightBody.processed }} />
        </div>
      </div>
    </CMSBlockWrapper>
  );
}
